var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_528",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 528",
    d: "M5977.87,852.41a16.538,16.538,0,1,1-5.75-12.5l-10.746,16.376-5.56-8.453-2.767,1.815,8.327,12.68,13.09-19.948A16.433,16.433,0,0,1,5977.87,852.41Z",
    transform: "translate(-5944.87 -835.91)",
    fill: "#d19f46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep);
export default __webpack_public_path__ + "static/media/step.01cb6b00b97fc70a06355a341c71448e.svg";
export { ForwardRef as ReactComponent };